import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { Link } from 'react-router-dom';
import { Forms } from '../../School/Forms/Forms';
import { Houses } from '../../School/Houses/Houses';
import './SchoolStructureRouting.css';

class SchoolStructureShell extends React.Component<any> {
  renderTabs(): React.ReactNode {
    const { location } = this.props;
    const isHouses = location.pathname.indexOf('/school/structure/houses') === 0;

    return (
      <div className="schoolStructure-tabs" role="tablist" aria-label="School structure">
        <Link
          className={!isHouses ? 'schoolStructure-tab schoolStructure-tab--active' : 'schoolStructure-tab'}
          to="/school/structure/forms"
          role="tab"
          aria-selected={!isHouses}
        >
          <span>Registration forms</span>
        </Link>
        <Link
          className={isHouses ? 'schoolStructure-tab schoolStructure-tab--active' : 'schoolStructure-tab'}
          to="/school/structure/houses"
          role="tab"
          aria-selected={isHouses}
        >
          <span>Houses</span>
        </Link>
      </div>
    );
  }

  render(): React.ReactNode {
    const { user, location } = this.props;
    const isHouses = location.pathname.indexOf('/school/structure/houses') === 0;

    return (
      <div className="schoolStructure">
        <header className="schoolStructure-head">
          <h1>School structure</h1>
          {this.renderTabs()}
        </header>
        <div className={`schoolStructure-content schoolStructure-content--${isHouses ? 'houses' : 'forms'}`}>
          <Switch>
            <Route exact path="/school/structure/forms" render={props => <Forms {...props} user={user} />} />
            <Route exact path="/school/structure/houses" render={props => <Houses {...props} user={user} />} />
            <Redirect to="/school/structure/forms" />
          </Switch>
        </div>
      </div>
    );
  }
}

export const SchoolStructureRedirect = () => <Redirect to="/school/structure/forms" />;
export const SchoolStructureHousesRedirect = () => <Redirect to="/school/structure/houses" />;

export const SchoolStructureRouting = allProps => {
  return (
    <Switch>
      <Route
        exact
        path="/school/structure"
        render={props => <SchoolStructureShell {...props} user={allProps.user} />}
      />
      <Route
        exact
        path="/school/structure/forms"
        render={props => <SchoolStructureShell {...props} user={allProps.user} />}
      />
      <Route
        exact
        path="/school/structure/houses"
        render={props => <SchoolStructureShell {...props} user={allProps.user} />}
      />
    </Switch>
  );
};

SchoolStructureRouting.displayName = 'SchoolStructureRouting';
